angular.module('impactx.deliverynote').controller('DeliveryNoteReminderResultCtrl', DeliveryNoteReminderResultCtrl);

DeliveryNoteReminderResultCtrl.$inject = ['$mdDialog', 'themeFactory'];

function DeliveryNoteReminderResultCtrl($mdDialog, themeFactory)
{
    var self = this;
    
    self.theme = themeFactory.getTheme();
    
    self.ok = function() {
        $mdDialog.hide();
    }
}